import React, { useEffect, useRef } from "react";
import "./VideoModal.css";

const VideoModal = ({ isOpen, onClose, videoUrl, title, language }) => {
  const modalRef = useRef(null);
  const videoRef = useRef(null);

  // Handle click outside to close modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  // Handle escape key
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  // Pause video when modal closes
  useEffect(() => {
    if (!isOpen && videoRef.current) {
      videoRef.current.pause();
    }
  }, [isOpen]);

  if (!isOpen || !videoUrl) {
    return null;
  }

  const handleShareClick = () => {
    if (navigator.share) {
      navigator.share({
        title: title,
        url: videoUrl,
      }).catch((error) => {
        fallbackShare();
      });
    } else {
      fallbackShare();
    }
  };

  const fallbackShare = () => {
    navigator.clipboard.writeText(videoUrl).then(() => {
      alert(language === "ar" ? "تم نسخ رابط الفيديو إلى الحافظة" : "Video link copied to clipboard");
    }).catch(() => {
      window.open(`https://wa.me/?text=${encodeURIComponent(videoUrl)}`, '_blank');
    });
  };

  return (
    <div className="video-modal-overlay">
      <div 
        ref={modalRef}
        className={`video-modal ${language === "ar" ? "rtl" : "ltr"}`}
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        {/* Header */}
        <div className="video-modal-header">
          <h3 className="video-modal-title">
            {title || (language === "ar" ? "الفيديو التعريفي" : "Promotional Video")}
          </h3>
          <div className="video-modal-controls">
            <button 
              className="video-modal-share-btn"
              onClick={handleShareClick}
              title={language === "ar" ? "مشاركة الفيديو" : "Share Video"}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
                <polyline points="16,6 12,2 8,6"/>
                <line x1="12" y1="2" x2="12" y2="15"/>
              </svg>
            </button>
            <button 
              className="video-modal-close-btn"
              onClick={onClose}
              title={language === "ar" ? "إغلاق" : "Close"}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Video Content */}
        <div className="video-modal-content">
          <video
            ref={videoRef}
            src={videoUrl}
            controls
            autoPlay
            className="video-modal-player"
            title={title || "Promotional Video"}
          >
            {language === "ar" ? "متصفحك لا يدعم تشغيل الفيديو" : "Your browser does not support the video tag."}
          </video>
        </div>

        {/* Footer with download link */}
        {/* <div className="video-modal-footer">
          <a 
            href={videoUrl}
            download
            className="video-modal-download-btn"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7,10 12,15 17,10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            {language === "ar" ? "تحميل الفيديو" : "Download Video"}
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default VideoModal;
